import { render } from "./CalendarSection.vue?vue&type=template&id=742a81aa&scoped=true"
import script from "./CalendarSection.vue?vue&type=script&lang=js"
export * from "./CalendarSection.vue?vue&type=script&lang=js"

import "./CalendarSection.vue?vue&type=style&index=0&id=742a81aa&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742a81aa"]])

export default __exports__